import { toast, TypeOptions } from "react-toastify";

export const toastAsHtmlElement = (message: string, type?: TypeOptions) => {
  toast(<div dangerouslySetInnerHTML={{ __html: message }}></div>, { type: type ?? "error" });
};
